import { httpCreate } from './http';

const http = httpCreate('/um/user');

export const umUser = {
	getUserList(body, params) {
		return http.post(`/list`, body, { params });
	},
	addTags(body) {
		return http.post(`/tags`, body);
	},
	removeTags(body) {
		return http.delete('/tags', { data: body });
	},
	addBlack(body) {
		return http.post(`/black`, body);
	},
	getOrderList(userId, params) {
		return http.get(`/orderList/${userId}`, { params });
	},
	export(body) {
		return http.post(`/export`, body);
	},
	send(params, body) {
		return http.post(`/send`, body, { params });
	},
	updateInfo(body) {
		return http.put(`/update`, body);
	},
	detail(id) {
		return http.get(`/detail/${id}`);
	},
};
